// extracted by mini-css-extract-plugin
export default {"message":"ReadMsg_message__i3MuX"};